import NDAv2 from './NDAv2';

// V2-only. The legacy Slate-based NDA editor (DocumentContainer) was removed;
// NDA now always renders the Plate-based NDAv2. The `editor.nda.v2` visibility
// key is retained in visibilityKeys.ts for reference/revert but is no longer read.
function NDA() {
    return <NDAv2 />;
}

export default NDA;
